// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LegalPage_wrapper__4_q11","nav":"LegalPage_nav__OLmbe"};